import React from "react";
import { useTranslation } from "react-i18next";
import { Eyebrow } from "../components/ui.jsx";
import { wireLinkStyles } from "./Privacy.jsx";

export default function ReturnPolicy() {
  const { t } = useTranslation();
  const softwareList = t("legal.returnPolicy.softwareList", { returnObjects: true });
  const physicalList = t("legal.returnPolicy.physicalList", { returnObjects: true });
  const procList = t("legal.returnPolicy.procList", { returnObjects: true });

  return (
    <main>
      <section className="bg-wash">
        <div className="container" style={{ padding: "56px 24px 56px", maxWidth: 880 }}>
          <Eyebrow>{t("legal.eyebrow")}</Eyebrow>
          <h1 className="tt-h tt-h-xl" style={{ marginTop: 24 }}>{t("legal.returnPolicy.title")}</h1>
          <Html as="p" style={prose} html={t("legal.returnPolicy.intro")} />
        </div>
      </section>

      <section style={{ padding: "8px 0 120px" }}>
        <div className="container" style={{ maxWidth: 820 }}>
          <H2>{t("legal.returnPolicy.softwareH")}</H2>
          <Html as="p" style={prose} html={t("legal.returnPolicy.softwareIntro")} />
          <ul style={listStyle}>
            {softwareList.map((li, i) => <Html key={i} as="li" html={li} />)}
          </ul>

          <H2>{t("legal.returnPolicy.physicalH")}</H2>
          <Html as="p" style={prose} html={t("legal.returnPolicy.physicalIntro")} />
          <ul style={listStyle}>
            {physicalList.map((li, i) => <Html key={i} as="li" html={li} />)}
          </ul>

          <H2>{t("legal.returnPolicy.procH")}</H2>
          <ol style={listStyle}>
            {procList.map((li, i) => <Html key={i} as="li" html={li} />)}
          </ol>

          <H2>{t("legal.returnPolicy.supportH")}</H2>
          <Html as="p" style={prose} html={t("legal.returnPolicy.supportP")} />

          <H3>{t("legal.returnPolicy.helpH")}</H3>
          <Html as="p" style={prose} html={t("legal.returnPolicy.helpP")} />
        </div>
      </section>
    </main>
  );
}

function Html({ as: Tag = "p", html, style, className }) {
  return <Tag style={style} className={className} dangerouslySetInnerHTML={{ __html: wireLinkStyles(html) }} />;
}

const prose = {
  marginTop: 16,
  fontSize: 16,
  lineHeight: 1.7,
  color: "var(--ink-2)",
  maxWidth: 760
};

const listStyle = {
  marginTop: 12,
  paddingLeft: 22,
  fontSize: 16,
  lineHeight: 1.7,
  color: "var(--ink-2)",
  maxWidth: 760,
  display: "flex",
  flexDirection: "column",
  gap: 10
};

function H2({ children }) {
  return (
    <h2
      className="tt-h tt-h-md"
      style={{ marginTop: 56, scrollMarginTop: 96 }}
    >
      {children}
    </h2>
  );
}

function H3({ children }) {
  return (
    <h3
      style={{
        marginTop: 32,
        fontFamily: "Satoshi, Inter, sans-serif",
        fontSize: 19,
        fontWeight: 700,
        letterSpacing: "-.012em",
        color: "var(--ink)"
      }}
    >
      {children}
    </h3>
  );
}
